"use client";
import { j as l } from "./jsx-runtime-CJ-St4mQ.mjs";
import { forwardRef as i } from "react";
import { t as n } from "./tv.config-BuYIgndg.mjs";
const c = n({
  base: ["p-2 rounded-lg"],
  variants: {
    isNotListTag: {
      true: ["flex flex-col flex-wrap"]
    }
  }
}), x = i((t, o) => {
  const { component: s = "ul", className: e, ownerState: m, ...a } = t, r = ["ul", "ol", "dl"].includes(s.toString());
  return /* @__PURE__ */ l.jsx(
    s,
    {
      ref: o,
      className: c({ isNotListTag: !r, class: e }),
      ...a
    }
  );
});
export {
  x as default
};
